// src/stores/counter-store.ts
import { createStore } from "zustand/vanilla";
import { IconProps } from "@iconify/react";

export type BreadcrumbsItem = {
  label: string;
  href: string;
  icon?: IconProps["icon"];
};

export type BreadcrumbsState = {
  breadcrumbs: BreadcrumbsItem[];
};

export type BreadcrumbsActions = {
  addBreadcrumb: (breadcrumb: BreadcrumbsItem) => void;
  setBreadcrumbs: (breadcrumbs: BreadcrumbsItem[]) => void;
};

export type BreadcrumbsStore = BreadcrumbsActions & BreadcrumbsState;

export const defaultInitState: BreadcrumbsState = {
  breadcrumbs: [],
};

export const createBreadcrumbsStore = (
  initState: BreadcrumbsState = defaultInitState,
) => {
  return createStore<BreadcrumbsStore>()((set) => ({
    ...initState,
    addBreadcrumb: (breadcrumb) =>
      set((state) => ({
        breadcrumbs: [...state.breadcrumbs, breadcrumb],
      })),
    setBreadcrumbs: (breadcrumbs) =>
      set((state) => ({
        breadcrumbs,
      })),
  }));
};
